import { Alley } from '../../../../services/entities/impl/blfApi/schemas/alley';
import { Upload } from '../../../../services/entities/impl/blfApi/schemas/upload';
import { ValidationResult } from '../../utils/validation/validateSchema';

/**
 * Extra validation checks beyond yup validation for the Alley.
 *
 * @param alley - The alley to validate against the uploads.
 * @param uploads - The list of uploads to validate.
 * @returns A ValidationResult object indicating whether the validation passed and any messages.
 */
export const validateAlley = (
  alley: Alley,
  uploads: Upload[]
): ValidationResult => {
  const matchingUpload = uploads.find((u) => u.fileName === alley.fileName);

  if (!matchingUpload) {
    return {
      valid: false,
      messages: [
        {
          path: 'fileName',
          message:
            'No matching upload found, this is expected if bag is still uploading.',
          severity: 'warning',
        },
      ],
    };
  }

  return { valid: true, messages: [] };
};
